module.exports = __webpack_public_path__ + "static/media/addons_and_upsells.89f9573e.png";